import { Typography, TypographyProps } from '@mui/material'
import React, { useMemo } from 'react'
import useStyles from './styles';

interface Props extends TypographyProps {
  text: string;
  fontWeight?: number;
}

export default function CustomText({
  text,
  fontWeight = 500,
  sx,
  ...props }: Props) {
  const styles = useStyles();

  return (
    <Typography
      {...props}
      className={styles.text}
      sx={{
        ...sx,
        fontWeight,
      }}
    >
      {text}
    </Typography>
  )
}
